import { render, staticRenderFns } from "./InvitationsTile.vue?vue&type=template&id=2f4717b8&scoped=true&"
import script from "./InvitationsTile.vue?vue&type=script&lang=js&"
export * from "./InvitationsTile.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsTile.vue?vue&type=style&index=0&id=2f4717b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4717b8",
  null
  
)

export default component.exports